import { useMemo } from 'react';

import {
  normalizeBuyerIntentId,
  warnMissingBuyerIntentIds,
} from 'components/BuyerIntent';
import { useAppContext } from 'context/AppContext';
import useLasForm from 'screens/serp/hooks/useLasForm';

/** @type {import("./types").default} */
const usePplForm = ({
  productId,
  sourceLocation,
  formTemplate,
  includeProductInConfig = false,
  enabled = true,
}) => {
  const { head } = useAppContext();
  const globalCategoryId = head?.data_layer?.[0]?.categoryPageUuid ?? null;

  const buyerIntentProductId = normalizeBuyerIntentId(productId);
  const buyerIntentCategoryId = normalizeBuyerIntentId(globalCategoryId);

  const config = useMemo(
    () =>
      includeProductInConfig
        ? { pGuid: productId, formTemplate }
        : { formTemplate },
    [includeProductInConfig, productId, formTemplate]
  );

  const openForm = useLasForm({
    hasPplExitIntentEnabled: false,
    global_category_id: globalCategoryId,
    config,
    form: 'openLasModal',
    hasCallFunction: true,
    enabled,
    isPPL: true,
  });

  const handleClick = () => {
    if (!buyerIntentProductId) {
      warnMissingBuyerIntentIds(sourceLocation, {
        productId,
        categoryId: globalCategoryId,
      });
    }
    openForm();
  };

  return {
    buyerIntentProductId,
    buyerIntentCategoryId,
    globalCategoryId,
    handleClick,
    openForm,
  };
};

export default usePplForm;
